var _rect, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoYoutubeConnected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.929688,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2286 11.2635C27.0931 10.7641 26.8288 10.3088 26.4619 9.94292C26.0951 9.57707 25.6385 9.31345 25.1377 9.17831C23.3044 8.67969 15.9255 8.67969 15.9255 8.67969C15.9255 8.67969 8.54673 8.6948 6.71338 9.19342C6.21259 9.32856 5.75603 9.59218 5.38918 9.95803C5.02233 10.3239 4.75798 10.7792 4.62247 11.2786C4.06792 14.5272 3.85277 19.4772 4.63762 22.5959C4.77313 23.0953 5.03748 23.5506 5.40433 23.9165C5.77118 24.2823 6.22774 24.5459 6.72854 24.6811C8.56188 25.1797 15.9407 25.1797 15.9407 25.1797C15.9407 25.1797 23.3195 25.1797 25.1529 24.6811C25.6537 24.5459 26.1102 24.2823 26.4771 23.9165C26.8439 23.5506 27.1083 23.0953 27.2438 22.5959C27.8286 19.3427 28.0089 14.3958 27.2286 11.2635Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.577 20.465L19.6983 16.9293L13.577 13.3936V20.465Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 26,
    r: 6,
    fill: "#21C07D",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutubeConnected);
export default __webpack_public_path__ + "static/media/logo_youtube_connected.c82e800a32600f834fbbc8f1c42815ee.svg";
export { ForwardRef as ReactComponent };